import { render, staticRenderFns } from "./ImageEditor.vue?vue&type=template&id=f96d7ae4&"
import script from "./ImageEditor.vue?vue&type=script&lang=ts&"
export * from "./ImageEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ImageEditor.vue?vue&type=style&index=0&id=f96d7ae4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports